<template>
    <div class="div-crud-sistema">
        <div :id="'Div' + nomeFormulario" :name="'Div' + nomeFormulario">
            <form :method="metodoFormulario" :action="linkAction" :id="nomeFormulario" :name="nomeFormulario">
                <div v-if="!edit">
                    <slot name="csrf">

                    </slot>
                </div>
                <input type="hidden" name="id_empresa" :value="cliente.id">
                <div class="form-row">
                    <div class="form-group col-md-4">
                        <label for="tipoCadastroPessoa">Tipo de Cadastro</label>
                        <select  v-if="edit" disabled id="tipoCadastroPessoa" name="tipoCadastroPessoa" class="form-control" v-model="tipoCadastro">
                            <option value="2">CNPJ</option>
                        </select>
                        <select  :disabled="visualizar"  v-else id="tipoCadastroPessoa" name="tipoCadastroPessoa" class="form-control" v-model="tipoCadastro">
                            <option value="2">CNPJ</option>
                        </select>
                    </div>
                </div>
                <div v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                    <div class="form-row">
                        <div class="form-group col-md-1">
                            <label for="inputCodigoEmpresa">Codigo Empresa</label>
                            <input :readonly="visualizar" v-if="!errors.codigoempresa" type="text" class="form-control" id="inputCodigoEmpresa" name="inputCodigoEmpresa" placeholder="Código Empresa" v-model="cliente.codigoempresa">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputCodigoEmpresa" name="inputCodigoEmpresa" placeholder="Código Empresa" v-model="cliente.codigoempresa">
                            <div class="invalid-feedback" v-if="errors.codigoempresa">
                                {{ errors.codigoempresa[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-1">
                            <label for="inputOrigem">Origem(CRM)</label>
                            <input :readonly="visualizar" v-if="!errors.origem" type="text" class="form-control" id="inputOrigem" name="inputOrigem" placeholder="Código Empresa" v-model="cliente.origem">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputOrigem" name="inputOrigem" placeholder="Código Empresa" v-model="cliente.origem">
                            <div class="invalid-feedback" v-if="errors.origem">
                                {{ errors.origem[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputRazaoSocial">Nome Completo</label>
                            <input :readonly="visualizar" v-if="!errors.nomecompleto" type="text" class="form-control" id="inputRazaoSocial" name="inputRazaoSocial" placeholder="Nome Completo" v-model="cliente.nomecompleto">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputRazaoSocial" name="inputRazaoSocial" placeholder="Nome Completo" v-model="cliente.nomecompleto">
                            <div class="invalid-feedback" v-if="errors.nomecompleto">
                                {{ errors.nomecompleto[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputNomeFantasia">Nome Reduzido</label>
                            <input :readonly="visualizar" v-if="!errors.nomereduzido" type="text" class="form-control" id="inputNomeFantasia" name="inputNomeFantasia" placeholder="Nome Reduzido" v-model="cliente.nomereduzido">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputNomeFantasia" name="inputNomeFantasia" placeholder="Nome Reduzido" v-model="cliente.nomereduzido">
                            <div class="invalid-feedback" v-if="errors.nomereduzido">
                                {{ errors.nomereduzido[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputCNPJ">CNPJ</label>
                            <the-mask :readonly="visualizar" :masked="true" v-if="!errors.cnpj" :mask="['##.###.###/####-##']" class="form-control" id="inputCNPJ" name="inputCNPJ" placeholder="CNPJ" v-model="doc"/>
                            <the-mask :readonly="visualizar" :masked="true" v-else :mask="['##.###.###/####-##']" class="form-control is-invalid" id="inputCNPJ" name="inputCNPJ" placeholder="CNPJ" v-model="doc"/>
                            <div class="invalid-feedback" v-if="errors.cnpj">
                                {{ errors.cnpj[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-2" >
                            <label for="inputCodigoEmpresa">Ativo</label><br/>
                                <b-form-checkbox
                                    id="cadastroAtivo"
                                    v-model="cliente.ativo"
                                    name="cadastroAtivo"
                                    :value="'Ativo'"
                                    :unchecked-value="'Inativo'"
                                    :disabled="visualizar"
                                    :switch="true"
                                    style="vertical-align: bottom !important;"
                                ></b-form-checkbox>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="inputCelular">E-mail</label>
                            <input :readonly="visualizar" type="text" v-if="!errors.email"  class="form-control" id="inputEmail" name="inputEmail" placeholder="E-mail " v-model="cliente.email">
                            <input :readonly="visualizar" type="text" v-else class="form-control is-invalid" id="inputEmail" name="inputEmail" placeholder="E-mail " v-model="cliente.email">
                            <div class="invalid-feedback" v-if="errors.email">
                                {{ errors.email[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputFone">Telefone</label>
                            <the-mask :readonly="visualizar" :masked="true" v-if="!errors.telefone" :mask="['(##)####-####','(##)#####-####']" type="text" class="form-control" id="inputFone" name="inputFone" placeholder="Telefone" v-model="cliente.telefone"/>
                            <the-mask :readonly="visualizar" :masked="true" v-else :mask="['(##)####-####','(##)#####-####']" type="text" class="form-control is-invalid" id="inputFone" name="inputFone" placeholder="Telefone" v-model="cliente.telefone"/>
                            <div class="invalid-feedback" v-if="errors.telefone">
                                {{ errors.telefone[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputCelular">Celular</label>
                            <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="text" class="form-control" id="inputCelular" name="inputCelular" placeholder="Celular" v-model="cliente.celular"/>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputEndereco">Endereço</label>
                            <input :readonly="visualizar" type="text" class="form-control" id="inputEndereco" name="inputEndereco" placeholder="Endereço, Nº" v-model="cliente.logradouro">
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputEndereco">Nº</label>
                            <input :readonly="visualizar" type="text" class="form-control" id="inputNumero" name="inputNumero" placeholder="Nº" v-model="cliente.numero">
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputEndereco">Complemento</label>
                            <input :readonly="visualizar" type="text" class="form-control" id="inputComplemento" name="inputComplemento" placeholder="Complemento" v-model="cliente.complemento">
                        </div>
                        
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label for="inputBairro">Bairro</label>
                            <input :readonly="visualizar" type="text" class="form-control" id="inputBairro" name="inputBairro" placeholder="Bairro, Distrito" v-model="cliente.bairro">
                        </div>
                        <div class="form-group col-md-3">
                            <label for="inputCidade">Cidade</label>
                            <input :readonly="visualizar" type="text" class="form-control" id="inputCidade" name="inputCidade" placeholder="Cidade" v-model="cliente.cidade">
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputUF">UF</label>
                            <select :disabled="visualizar" id="inputUF" name="inputUF" class="form-control" v-model="cliente.estado">
                                <option value="">Selecione o Estado</option>
                                <option value="RS">RS</option>
                                <option value="AC">AC</option>
                                <option value="AL">AL</option>
                                <option value="AM">AM</option>
                                <option value="AP">AP</option>
                                <option value="BA">BA</option>
                                <option value="CE">CE</option>
                                <option value="DF">DF</option>
                                <option value="ES">ES</option>
                                <option value="GO">GO</option>
                                <option value="MA">MA</option>
                                <option value="MG">MG</option>
                                <option value="MS">MS</option>
                                <option value="MT">MT</option>
                                <option value="PA">PA</option>
                                <option value="PB">PB</option>
                                <option value="PE">PE</option>
                                <option value="PI">PI</option>
                                <option value="PR">PR</option>
                                <option value="RJ">RJ</option>
                                <option value="RN">RN</option>
                                <option value="RO">RO</option>
                                <option value="RR">RR</option>
                                <option value="SC">SC</option>
                                <option value="SE">SE</option>
                                <option value="SP">SP</option>
                                <option value="TO">TO</option>
                            </select>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputCidade">País</label>
                            <input :readonly="visualizar" type="text" class="form-control" id="inputPais" name="inputPais" placeholder="País" v-model="cliente.pais">
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputCep">CEP</label>
                            <the-mask :readonly="visualizar" :masked="true" :mask="['#####-###']" type="text" class="form-control" id="inputCep" name="inputCep" placeholder="CEP"  v-model="cliente.cep"/>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-3">
                            <label for="inputUrlApiRubeus">URL API RUBEUS</label>
                            <input :readonly="visualizar" v-if="!errors.urlapirubeus" type="text" class="form-control" id="inputUrlApiRubeus" name="inputUrlApiRubeus" placeholder="URL API RUBEUS" v-model="cliente.urlapirubeus">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputUrlApiRubeus" name="inputUrlApiRubeus" placeholder="URL API RUBEUS" v-model="cliente.urlapirubeus">
                            <div class="invalid-feedback" v-if="errors.urlapirubeus">
                                {{ errors.urlapirubeus[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputTokenApiRubeus">TOKEN RUBEUS</label>
                            <input :readonly="visualizar" v-if="!errors.nomecompleto" type="text" class="form-control" id="inputTokenApiRubeus" name="inputTokenApiRubeus" placeholder="TOKEN API RUBEUS" v-model="cliente.tokenapirubeus">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputTokenApiRubeus" name="inputTokenApiRubeus" placeholder="TOKEN API RUBEUS" v-model="cliente.tokenapirubeus">
                            <div class="invalid-feedback" v-if="errors.tokenapirubeus">
                                {{ errors.tokenapirubeus[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <label for="inputUrlApiGvdasa">URL API GVDASA</label>
                            <input :readonly="visualizar" v-if="!errors.urlapigvdasa" type="text" class="form-control" id="inputUrlApiGvdasa" name="inputUrlApiGvdasa" placeholder="URL API GVDASA" v-model="cliente.urlapigvdasa">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputUrlApiGvdasa" name="inputUrlApiGvdasa" placeholder="URL API GVDASA" v-model="cliente.urlapigvdasa">
                            <div class="invalid-feedback" v-if="errors.urlapigvdasa">
                                {{ errors.urlapigvdasa[0] }}
                            </div>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="inputTokenApiGvdasa">TOKEN GVDASA</label>
                            <input :readonly="visualizar" v-if="!errors.tokenapigvdasa" type="text" class="form-control" id="inputTokenApiGvdasa" name="inputTokenApiGvdasa" placeholder="TOKEN API GVDASA" v-model="cliente.tokenapigvdasa">
                            <input :readonly="visualizar" v-else type="text" class="form-control is-invalid" id="inputTokenApiGvdasa" name="inputTokenApiGvdasa" placeholder="TOKEN API GVDASA" v-model="cliente.tokenapigvdasa">
                            <div class="invalid-feedback" v-if="errors.tokenapigvdasa">
                                {{ errors.tokenapigvdasa[0] }}
                            </div>
                        </div>
                        <div class="col-md-2" v-if="users.length>0">
                            <label for="inputRepresentante">Responsável</label>
                            <select :disabled="visualizar" name="inputRepresentante" id="inputRepresentante" class="form-control" v-model="responsavel_id" >
                                <option :value="0">Selecione o Responsável</option>
                                <option v-for="user in users" :key="user.id" :value="user.id">{{user.nome}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row" v-if="users.length>0">
                    </div>
                </div>
                <br/>
                <a :href="'/'+urlSistema" class="btn btn-primary">Cancelar</a>
                <button :disabled="visualizar" type="button" class="btn btn-primary" @click="insereOuAtualiza()">Salvar</button>
                <!--button :disabled="visualizar || cliente.idexportacaocrm > 0 || cliente.id==''" type="button" class="btn btn-primary" @click="exportarEmpresaCrm(cliente)" v-if="cliente.tokenapirubeus && cliente.tokenapirubeus">Exportar para Rubeus</button-->
            </form>
        </div>
        <modal-component titulo="Mensagem do Sistema" label-btn-fechar="OK" id="MensagemSistema" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
            </template>
            <template v-slot:conteudo>
                <table class="table table-sm table-hover" style="margin: 0px;">
                    <thead style="background:#1c4d5a!important;color:white;white-space: nowrap;">
                        <tr>
                            <th colspan="2" style="text-align:center;border: 0px;">
                                EMPRESA
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="2" style="padding:0px;">
                                <div class="alert alert-success" role="alert" style="margin:0px;text-align: center;">
                                    <b v-if="edit">Atualizado com sucesso!</b>
                                    <b v-else>Cadastrado com sucesso!</b>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align:left;">
                                <b>ID:</b> {{ cliente.id }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align:left;">
                                <b>NOME:</b> {{ cliente.nomecompleto }}                                    
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align:left;">
                                <b>CNPJ:</b> {{ cliente.cnpj }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </modal-component>
        <modal-component titulo="Exportação CRM" label-btn-fechar="OK" id="ExportacaoCrmMsg" :url-redirect="'/'+urlSistema+'/'" :sem-padding="true">
            <template v-slot:titulo>
                Exportação CRM
            </template>
            <template v-slot:conteudo>
                <table class="table table-sm table-hover ">
                    <thead style="background:#1c4d5a!important;color:white;white-space: nowrap;">
                        <tr>
                            <th colspan="2" style="text-align:center;">
                                EMPRESA
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="2" style="padding:0px;">
                                <div class="alert alert-success" role="alert" style="margin:0px;text-align: center;">
                                    <b>Empresa Exportada para o CRM</b>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align:left;">
                                <b>Código:</b> {{ empresa_exportada_crm.codigoempresa }}
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align:left;">
                                <b>Id Exportação:</b> {{ empresa_exportada_crm.idexportacaocrm }}                                   
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align:left;">
                                <b>Descrição Unidade:</b> {{ empresa_exportada_crm.nomecompleto }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </modal-component>
        <loading id="SalvandoCompany" titulo="Salvando Empresa, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
    </div>
</template>

<script>


export default{

    methods:{
        dissmiss(id){
            this.$bvModal.hide(id);
        },
        novo(id){
            this.user = {}
            this.modoeditar = false
            this.modoexcluir = false
            this.modonovo = true
            this.texto_modal = "Novo"
            this.user.id=id
            // console.log(this.user)
        },
        editar(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = true
            this.modoexcluir = false
            this.modonovo = false
            this.texto_modal = "Editar"
            // console.log(this.user)
            // console.log(this.user)
        },
        excluir(usuarioSelecionado){
            this.user = usuarioSelecionado;
            this.modoeditar = false
            this.modoexcluir = true
            this.modonovo = false
            this.texto_modal = "Excluir"
            // console.log(this.user)
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        resetModal() {
            this.name = ''
            this.nameState = null
        },
        removerPorId: function (id) {
            var _vm = this; //Adicionando a instância à uma variável, para que possa ser acessada dentro do forEach`
            this.users.forEach(function(el, index) {
                if(el.id === id)
                    _vm.users.splice(index, 1);
            })
        },
        insereOuAtualiza(){
            if(!this.edit){
                this.inserirCompany();
                console.log('insere')
            }else{
                this.atualizaCompany();
                console.log('atualiza')
            }
        },
        inserirCompany(){
            // if(this.modonovo){
                $('#SalvandoCompany').modal('show');
                let url='/api/v1/'+this.urlSistema;
                console.log(url)
                let formData = new FormData();
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('codigoempresa', (this.cliente.codigoempresa?this.cliente.codigoempresa:''))
                formData.append('nomecompleto', (this.cliente.nomecompleto?this.cliente.nomecompleto:''))
                formData.append('cnpj', (this.cliente.cnpj?this.cliente.cnpj:''))
                formData.append('email', (this.cliente.email?this.cliente.email:''))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('logradouro', (this.cliente.logradouro?this.cliente.logradouro:''))
                formData.append('numero', (this.cliente.numero?this.cliente.numero:''))
                formData.append('complemento', (this.cliente.complemento?this.cliente.complemento:''))
                formData.append('bairro', (this.cliente.bairro?this.cliente.bairro:''))
                formData.append('cidade', (this.cliente.cidade?this.cliente.cidade:''))
                formData.append('estado', (this.cliente.estado && this.cliente.estado != '0' ?this.cliente.estado:''))
                formData.append('cep', (this.cliente.cep?this.cliente.cep:''))
                formData.append('urlapirubeus', (this.cliente.urlapirubeus?this.cliente.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.cliente.tokenapirubeus?this.cliente.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.cliente.urlapigvdasa?this.cliente.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.cliente.tokenapigvdasa?this.cliente.tokenapigvdasa:''))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('origem', (this.cliente.origem?this.cliente.origem:''))
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.cliente.nomereduzido?this.cliente.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.cliente.email?this.cliente.email:''))

                let configuracao = {
                    // method:'post',
                    // headers:{
                    //     // // 'Accept': 'application/json',
                    //     // // 'Authorization': this.$root.token(),
                    // }
                }
                
                axios.post(url,formData,configuracao)
                    .then(response => {
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        this.errors={};
                        this.cliente.CadastroTipo=2
                        $('#SalvandoCompany').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response)
                    })
            // }
        },
        atualizaCompany(){
            // if(this.modonovo){
                $('#SalvandoCompany').modal('show');
                let url='/api/v1/'+this.urlSistema+'/'+this.cliente.id;
                console.log(url)
                //console.log(this.cliente)                                  
                let formData = new FormData();
                formData.append('_method','patch');
                formData.append('tipocadastro', this.tipoCadastro)
                formData.append('codigoempresa', (this.cliente.codigoempresa?this.cliente.codigoempresa:''))
                formData.append('nomecompleto', (this.cliente.nomecompleto?this.cliente.nomecompleto:''))
                formData.append('cnpj', (this.cliente.cnpj?this.cliente.cnpj:''))
                formData.append('email', (this.cliente.email?this.cliente.email:''))
                formData.append('telefone', (this.cliente.telefone?this.cliente.telefone:''))
                formData.append('celular', (this.cliente.celular?this.cliente.celular:''))
                formData.append('logradouro', (this.cliente.logradouro?this.cliente.logradouro:''))
                formData.append('numero', (this.cliente.numero?this.cliente.numero:''))
                formData.append('complemento', (this.cliente.complemento?this.cliente.complemento:''))
                formData.append('bairro', (this.cliente.bairro?this.cliente.bairro:''))
                formData.append('cidade', (this.cliente.cidade?this.cliente.cidade:''))
                formData.append('estado', (this.cliente.estado && this.cliente.estado != '0' ?this.cliente.estado:''))
                formData.append('cep', (this.cliente.cep?this.cliente.cep:''))
                formData.append('urlapirubeus', (this.cliente.urlapirubeus?this.cliente.urlapirubeus:''))
                formData.append('tokenapirubeus', (this.cliente.tokenapirubeus?this.cliente.tokenapirubeus:''))
                formData.append('urlapigvdasa', (this.cliente.urlapigvdasa?this.cliente.urlapigvdasa:''))
                formData.append('tokenapigvdasa', (this.cliente.tokenapigvdasa?this.cliente.tokenapigvdasa:''))
                formData.append('ativo',(this.cliente.ativo=='Ativo'?'1':'0'))
                formData.append('origem', (this.cliente.origem?this.cliente.origem:''))
                if(this.responsavel_id>0){
                    formData.append('responsavel_id', (this.responsavel_id))
                }
                if(this.tipoCadastro==2){
                    formData.append('nomereduzido', (this.cliente.nomereduzido?this.cliente.nomereduzido:''))
                }else{
                    formData.append('nomereduzido', '')
                }
                formData.append('email',(this.cliente.email?this.cliente.email:''))
                
                let configuracao = {
                    // method:'put',
                    // headers:{
                    // //     'Accept': 'application/json',
                    // //     'Authorization': this.$root.token()
                    // },
                }
                
                axios.post(url, formData,configuracao)
                    .then(response => {
                        // console.log(response)
                        this.transacaoStatus = response.status
                        this.cliente = response.data.usuarioNovo;
                        this.errors={};
                        this.cliente.CadastroTipo=2
                        $('#SalvandoCompany').modal('hide');
                        $('#MensagemSistema').modal('show');
                    })
                    .catch(errors => {
                        this.errors = errors.response.data.errors
                        console.log(errors.response.data)
                        $('#SalvandoCompany').modal('hide');
                    })
            // }
        },
        exportarEmpresaCrm(unidade){
            let url='/api/v1/Companies/Company/CadastroLocaisOferta/'+this.cliente.id;
                
                //console.log(this.cliente)                                  
                
                
            let configuracao = {
                // method:'put',
                // headers:{
                // //     'Accept': 'application/json',
                // //     'Authorization': this.$root.token()
                // },
            }
            
            axios.post(url,configuracao)
                .then(response => {
                    this.empresa_exportada_crm = response.data
                    console.log(this.empresa_exportada_crm)
                    // this.empresa_exportada_crm.id = response.data.resposta_crm.id
                    $('#ExportacaoCrmMsg').modal('show');
                })
                .catch(errors => {
                    this.errors = errors.response.data.errors
                    console.log(errors.response.data)
                })
        },
        excluirUsuarioCliente(id){
            
            if(this.modoexcluir){
                var config = {
                method: 'delete',
                url: '/api/v1/'+this.urlSistema+'/'+id,
                // headers: {
                //         // 'Accept': 'application/json',
                //         // 'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                    debugger;
                    // console.log(response.data.usuario)
                    this.$bvModal.hide('modal-prevent-closing')
                    this.$nextTick(() => {
                        window.alert("Usuário de Cliente excluído com sucesso");
                    })
                    this.removerPorId(id)
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
        }
    },
    mounted(){
        // this.$root.atualizaCookie('token');
    },
    created(){

        if(this.pessoa){
            this.cliente = this.pessoa;
            console.log(this.cliente)
            this.users = this.usuarios;
            this.doc=this.pessoa.cnpj;
            
            if(this.pessoa.responsavel_id>0){
                this.responsavel_id=this.pessoa.responsavel_id
            }

            if(this.pessoa.cnpj.length==14){
                this.cliente.CadastroTipo=1
                this.cliente.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=1
            }else if(this.pessoa.cnpj.length==18){
                this.cliente.CadastroTipo=2
                this.cliente.cnpj = this.pessoa.cnpj;
                this.tipoCadastro=2
            }else{
                this.cliente.CadastroTipo=2
                this.tipoCadastro=2
            }
        }else{
            this.cliente.CadastroTipo=2;
            this.tipoCadastro=2;
            this.cliente.estado="0";
        }
    },
    props:{
        urlSistema:{
            type:String,
            required:true
        },
        visualizar:{
            type:Boolean,
            required:true
        },
        nomeFormulario:{
            type:String,
            required:true
        },
        metodoFormulario:{
            type:String,
            required:true
        },
        linkAction:{
            type:String,
            required:true
        },
        pessoa:{
            type:Object,
            required:false
        },
        usuarioAutenticado:{
            type:Object,
            required:false
        },
        usuarios:[],
        edit:{
            type:Boolean,
            required:true
        }
    },
    watch: {
    // whenever question changes, this function will run
        texto_modal(newTexto, oldTtexto) {
            if (newTexto!=oldTtexto) {
                this.texto_modal=newTexto;
            }
        }
        ,tipoCadastro(newTipoCadastro, oldTipoCadastro) {
            if (newTipoCadastro!=oldTipoCadastro) {
                this.cliente.CadastroTipo=newTipoCadastro;
                this.tipoCadastro=newTipoCadastro;
                this.errors={};
            }
        },
        doc(newdoc, olddoc) {
            if (newdoc!=olddoc) {
                this.cliente.cnpj=newdoc;
                this.doc=newdoc;
            }
        },
    },
    data(){
        return{
            transacaoStatus:null,
            modonovo:false,
            modoeditar:false,
            modoexcluir:false,
            Novo:false,
            texto_modal:'',
            nameState: null,
            senhaState:null,
            emailState:null,
            submittedNames: [],
            tipoCadastro:null,
            doc:null,
            cliente:{
                id:null,
                nomecompleto:null,
                nomereduzido:null,
                cnpj:null,
                logradouro:null,
                numero:null,
                complemento:null,
                cep:null,
                pais:null,
                estado:null,
                cidade:null,
                bairro:null,
                site:null,
                email:null,
                telefone:null,
                celular:null,
                codigoempresa:null,
                origem:null,
                /**
                 * cpf = 1
                 * cnpj = 2
                 */
                CadastroTipo:0,
                // link_integracao_gvdasa:null,
                // token_api_gvdasa:null,
                // link_integracao_rubeus:null,
                // token_api_rubeus:null,
                // origem:null,

            },
            user:{
                id:null,
                name:null,
                email:null,
                senha:null,
            },
            responsavel_id:0,
            users:[],
            errors:{},
            empresa_exportada_crm:[{
                id:null,
                codigo:null,
                descricao:null,
                nome:null,
                oridem:null
            }],
        }
    }
}
</script>

<style scoped>
    form{
        text-align: left!important;
    }

    .div-crud-sistema{
        background: white;
        padding: 15px;
        border-radius: 10px;

    }

</style>
